import { render, staticRenderFns } from "./EditPlannerIntroduce.vue?vue&type=template&id=2822e186&"
import script from "./EditPlannerIntroduce.vue?vue&type=script&lang=js&"
export * from "./EditPlannerIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports